import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Alert, Box, Card, CardContent, CircularProgress, Typography } from '@mui/material'

import { useAuth } from '../hooks/useAuth'

export function AuthCallbackPage() {
  const { loginWithToken } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState(searchParams.get('error') || '')

  useEffect(() => {
    const token = searchParams.get('token')
    const callbackError = searchParams.get('error')

    if (callbackError) {
      setError(callbackError)
      return
    }

    if (!token) {
      setError('Microsoft sign-in did not return an access token.')
      return
    }

    loginWithToken(token)
      .then(() => {
        navigate('/', { replace: true })
      })
      .catch(() => {
        setError('Microsoft sign-in could not be completed.')
      })
  }, [loginWithToken, navigate, searchParams])

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ background: 'linear-gradient(135deg, #0f4c81, #1f6fb2)' }}
    >
      <Card sx={{ width: 420, p: 2 }}>
        <CardContent>
          {error ? (
            <Alert severity="error">{error}</Alert>
          ) : (
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
              <CircularProgress />
              <Typography variant="body1">Completing Microsoft sign-in...</Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}
